type RoundingMethod = "round" | "ceil" | "floor";

const mathUtils = {
  /**
   * 四捨五入到指定位數
   * @param value - The number to be rounded.
   * @param digits - The number of decimal places to round to (default is 0).
   * @returns The number rounded to the specified decimal places.
   */
  round: (value: number, digits = 0) => {
    const factor = 10 ** digits;
    return Math.round(value * factor) / factor;
  },
  /**
   * 無條件捨去到指定位數
   * @param value - The number to be floored.
   * @param digits
   * @returns
   */
  floor: (value: number, digits = 0) => {
    const factor = 10 ** digits;
    return Math.floor(value * factor) / factor;
  },
  /**
   * 將數值轉為百分比字串，可指定小數位數與取整方式
   * @param value - 要轉換的數值（如 0.256)
   * @param digits - 小數位數（預設為 0)
   * @param method - 取整方法：'round' | 'ceil' | 'floor'（預設為 'round')
   * @returns 格式化後的百分比字串（如 "25.6%")
   */
  toPercentage: (value: number, digits = 0, method: RoundingMethod = "round"): string => {
    const factor = 10 ** digits;
    const methods: Record<RoundingMethod, (n: number) => number> = {
      round: Math.round,
      ceil: Math.ceil,
      floor: Math.floor,
    };

    const raw = value * 100 * factor;
    const rounded = methods[method](raw) / factor;
    return `${rounded}%`;
  },
};

/** 數值處理工具集：四捨五入、無條件捨去、百分比格式化 */
export default mathUtils;
